exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-chip {\r\n  font-size: 15px;\r\n  border-radius: 10px;\r\n  padding: 3px;\r\n}\r\n\r\n.title-chip {\r\n  font-size: 20px;\r\n}\r\n\r\n.card-as-row {\r\n  cursor: pointer;\r\n  margin: 5px;\r\n}\r\n.card-as-row:hover {\r\n  box-shadow: rgba(63,81,181,1) 0 0 15px;\r\n}\r\n\r\n.ticket-col-1 {\r\n  display: inline-block;\r\n  width: 70%;\r\n}\r\n.ticket-col-2 {\r\n  text-align: right;\r\n  display: inline-block;\r\n  width: calc(15% - 5px);\r\n}\r\n.ticket-col-3 {\r\n  text-align: right;\r\n  display: inline-block;\r\n  width: calc(15% - 5px);\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/AppDev/meetup/kla-firebase-poker/web/src/app/component/ticket-list/ticket-list.component.css
// module id = ../../../../../src/app/component/ticket-list/ticket-list.component.css
// module chunks = main